import { useAct } from 'DashboardUser/store'
import AddFilterPill from "./AddFilterPill";
import EditFilterPill from "./EditFilterPill";

export default function FilterPills() {
    const act = useAct();
    
    const filters = useSel(s => s.local.filters);
    const hasActiveFilters = useSel(s => Object.keys(s.local.filters).filter(k => s.local.filters[k] != null).length > 0);

    const clearAllFilters = () => {
        act.local.clearFilters();
    }

    return (
        <div className="filter-pills-container">
            {/* Something for each each of the active filters here */}
            <AddFilterPill />
            {Object.keys(filters).filter(k => k !== 'searchText').map(key => <EditFilterPill key={key} filterKey={key} />)}
            {hasActiveFilters && <a className="reset-filters" href="#" onClick={clearAllFilters}>Reset all</a>}
        </div>
    )
}